export const environment = {
    production: false,
    panel: 'diamondv8_',
    // domain: "2023exch.com",
    // baseUrl: "https://api.2023exch.com",
    domain: "jarvisexch.com",
    baseUrl: "https://jarvisexch.com",
    pollers: {
        oddsData: 600,
        listOddsData: 10000,
        scoresData: 1000,
    },
    trafficTag: '',
    noDataMsg: 'No Data Found',
    isMobile: true,
    isBetOpenEnv: false,
    wpLinkShowPages: '/home',
    demoDWLink: '',
    demoLoginUserName: 'demo123',
    stakes: { "stake_name_1": "100", "stake_name_2": "5000", "stake_name_3": "500", "stake_name_4": "25000", "stake_name_5": "50000", "stake_name_6": "100000", "stake_name_7": "500000", "stake_name_8": "1000000", "stake_amount_1": 100, "stake_amount_2": 5000, "stake_amount_3": 500, "stake_amount_4": 25000, "stake_amount_5": 50000, "stake_amount_6": 100000, "stake_amount_7": 500000, "stake_amount_8": 1000000 },
    horseRaceJockeyImgPrefix: 'https://content-cache.cdnbf.net/feeds_images/Horses/SilkColours/',
    desktopStyles: [],
    mobileStyles: [],
    host: {
        domain: '',
        apiDomain: '',
        name: '',
        dName: '',
        ext: '',
        theme: '',
        email: '',
        content: '',
        whatsapptext: '',
        demoLogin: false,
        guestEnable: false,
        signUpActive: false,
        iframeDomainUrl: '',
        depoWithdraw: false,
        demoLoginWpLink: '',
        guestWhatsappLink: '',
        social: {
            isShow: false,
            wpLink: '',
            fbLink: '',
            instaLink: '',
            telLink: '',
            tel2Link: '',
        },
        footerone: {
            isShow: false,
        },
        footertwo: {
            isShow: false,
        },
        footerthree: {
            isShow: false,
        },
        footerbottomone: {
            isShow: false,
        },
        footerbottomtwo: {
            isShow: false,
        },
        ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
        pusher: {
            key: '',
            cluster: '',
        },
        downloadApk: '',
        afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
        mThemePath: [''],
        dThemePath: [''],
        tawkToSrc: '',
        gTag: false,
        metaSeoContent:'',
    },
    hosts: [
        {
            domain: 'localhost',
            apiDomain: 'localhost',
            name: 'localhost',
            dName: 'LocalHost',
            ext: '.com',
            theme: 'blue-body',
            email: 'contactmybetbhai@gmail.com',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'magicexch.com',
            apiDomain: 'magicexch.com',
            name: 'magicexch',
            dName: 'magicexch',
            ext: '.com',
            theme: 'blue-body',
            email: 'magicexchinfo@gmail.com',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: 'https://application-hub.pages.dev/MagicExch.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'magicexch.io',
            apiDomain: 'magicexch.io',
            name: 'magicexch',
            dName: 'magicexch',
            ext: '.io',
            theme: 'blue-body',
            email: 'magicexchinfo@gmail.com',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: 'https://application-hub.pages.dev/MagicExch.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mymatch99.com',
            apiDomain: 'mymatch99.com',
            name: 'mymatch99',
            dName: 'mymatch99',
            ext: '.com',
            theme: 'blue-body',
            email: 'mymatch99info@gmail.com',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_myMatch.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_myMatch.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'shakunee247.com',
            apiDomain: 'shakunee247.com',
            name: 'shakunee247',
            dName: 'shakunee247',
            ext: '.com',
            theme: 'blue-body',
            email: 'shakunee247info@gmail.com',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_shakunee247.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_shakunee247.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'wold77.com',
            apiDomain: 'wold77.com',
            name: 'wold77',
            dName: 'wold77',
            ext: '.com',
            theme: 'blue-body',
            email: 'wold77info@gmail.com',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_wold77.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_wold77.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '11starss.in',
            apiDomain: '11starss.in',
            name: '11starss',
            dName: '11starss',
            ext: '.in',
            theme: 'blue-body',
            email: '11starssinfo@gmail.com',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            iframeDomainUrl: 'https://77panel.com/',
            signUpActive: false,
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '4ae8dfadca375e6d7f9f',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_11star.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_11star.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '33exch.com',
            apiDomain: '33exch.com',
            name: '33exch',
            dName: '33exch',
            ext: '.com',
            theme: 'blue-body',
            email: '33exchinfo@gmail.com',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://77panel.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '4ae8dfadca375e6d7f9f',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'aarav999.com',
            apiDomain: 'aarav999.com',
            name: 'aarav999',
            dName: 'aarav999',
            ext: '.com',
            theme: 'blue-body',
            email: 'aarav999info@gmail.com',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://application-hub.pages.dev/aarav999.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/m-theme_aarav999.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_aarav999.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'lio777.com',
            apiDomain: 'lio777.com',
            name: 'lio777',
            dName: 'lio777',
            ext: '.com',
            theme: 'blue-body',
            email: 'lio777info@gmail.com',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://application-hub.pages.dev/lio777.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/m-theme_aarav999.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_aarav999.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'crickbuzz247.co',
            apiDomain: '1xbetfair.me',
            name: 'crickbuzz247',
            dName: 'crickbuzz247',
            ext: '.co',
            theme: 'blue-body',
            email: 'crickbuzz247info@gmail.com',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/1xbetfair.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_crickbuzz247.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_crickbuzz247.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'kingcrex.com',
            apiDomain: 'kingcrex.com',
            name: 'kingcrex',
            dName: 'kingcrex',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/247support',
                fbLink: '',
                instaLink: '',
                telLink: 'https://t.me/kingcrex',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'fdf9a08dc1f2bfa9cffa',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_blue.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_blue.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'zebraexch9.com',
            apiDomain: 'zebraexch9.com',
            name: 'zebraexch9',
            dName: 'zebraexch9',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_zebraexch9.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_zebraexch9.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '1xbetfair.org',
            apiDomain: '1xbetfair.org',
            name: '1xbetfair',
            dName: '1xbetfair',
            ext: '.org',
            theme: 'blue-body',
            email: 'info1xbetfair@gmail.com',
            content: 'Welcome to 1xbetfair, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: 'https://www.facebook.com/1xbetfair',
                instaLink: 'https://www.instagram.com/1xbetfair',
                telLink: 'https://t.me/onexbetfair',
                tel2Link: 'https://t.me/onexbetfairsupport',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-1xbetfairmarket.webp',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'indusbook247.com',
            apiDomain: 'indusbook247.com',
            name: 'indusbook247',
            dName: 'indusbook247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_indusbook247.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_indusbook247.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'allbet9.com',
            apiDomain: 'magicexch.com',
            name: 'allbet9',
            dName: 'allbet9',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '1xbetfair.in',
            apiDomain: '1xbetfair.in',
            name: '1xbetfair',
            dName: '1xbetfair',
            ext: '.in',
            theme: 'blue-body',
            email: 'info1xbetfair@gmail.com',
            content: 'Welcome to 1xbetfair, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/1xsupport',
                fbLink: 'https://www.facebook.com/1xbetfair',
                instaLink: 'https://www.instagram.com/1xbetfair',
                telLink: 'https://t.me/onexbetfair',
                tel2Link: 'https://t.me/onexbetfairsupport',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '1xbetfair.co',
            apiDomain: '1xbetfair.co',
            name: '1xbetfair',
            dName: '1xbetfair',
            ext: '.co',
            theme: 'blue-body',
            email: 'info1xbetfair@gmail.com',
            content: 'Welcome to 1xbetfair, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://awl247wa.com/casino/1xbetfair',
            guestWhatsappLink: 'https://awl247wa.com/casino/1xbetfair',
            social: {
                isShow: true,
                wpLink: '',
                fbLink: 'https://www.facebook.com/1xbetfeir',
                instaLink: 'https://www.instagram.com/1xbetfeir?igsh=enRiNXdnOTZjbXFk&utm_source=qr',
                telLink: 'https://t.me/onexbetfair',
                tel2Link: 'https://t.me/onexbetfairsupport',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/1xbetfair.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-1xbetfair-apk-download2026.webp',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: 'https://embed.tawk.to/69e5d2696ef56e1c36f545c8/1jmkrrrco',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '1xbetfair.com',
            apiDomain: '1xbetfair.com',
            name: '1xbetfair',
            dName: '1xbetfair',
            ext: '.com',
            theme: 'blue-body',
            email: 'info1xbetfair@gmail.com',
            content: 'Welcome to 1xbetfair, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/1xbetfair',
                fbLink: 'https://www.facebook.com/1xbetfair',
                instaLink: 'https://www.instagram.com/1xbetfair',
                telLink: 'https://t.me/onexbetfair',
                tel2Link: 'https://t.me/onexbetfairsupport',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'taj365.co',
            apiDomain: 'taj365.co',
            name: 'taj365',
            dName: 'taj365',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: 'https://application-hub.pages.dev/MagicExch.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'babaexch24.com',
            apiDomain: 'babaexch24.com',
            name: 'babaexch24',
            dName: 'babaexch24',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '5b1dec503fbd6e8b176c',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_myMatch.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_myMatch.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'titoosports.com',
            apiDomain: 'kanhaexch.com',
            name: 'titoosports',
            dName: 'titoosports',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '5b1dec503fbd6e8b176c',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_titoosports.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_titoosports.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'titoosports.co',
            apiDomain: 'titoosports.co',
            name: 'titoosports',
            dName: 'titoosports',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '5b1dec503fbd6e8b176c',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_titoosports.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_titoosports.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'aladdinbook.com',
            apiDomain: 'aladdinbook.com',
            name: 'aladdinbook',
            dName: 'aladdinbook',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to aladdinbook, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'fdf9a08dc1f2bfa9cffa',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_aladdinbook.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_aladdinbook.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'ambikaonline.com',
            apiDomain: '1xbetfair.me',
            name: 'ambikaonline',
            dName: 'ambikaonline',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://bio.wa.link/ambikaexchangesupport',
            guestWhatsappLink: 'https://bio.wa.link/ambikaexchangesupport',
            social: {
                isShow: true,
                wpLink: 'https://go.wa.link/ambikaexchangesupport',
                fbLink: 'https://www.facebook.com/ambikaexchangeofficial1',
                instaLink: 'https://www.instagram.com/ambikaexchangeofficial',
                telLink: 'https://t.me/Ambikaexchangeofficial',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/Ambika.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-ambikaonline.webp',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_ambika.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_ambika.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mahaexchange.com',
            apiDomain: 'mahaexchange.com',
            name: 'mahaexchange',
            dName: 'mahaexchange',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/allwhitelabel247',
                fbLink: 'https://www.facebook.com/AllWhitelabel247official/',
                instaLink: 'https://www.instagram.com/allwhitelabel247',
                telLink: 'https://t.me/allwhitelabel247',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'willsexch.co',
            apiDomain: 'willsexch.co',
            name: 'willsexch',
            dName: 'willsexch',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to willsexch, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: false,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: false,
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '5b1dec503fbd6e8b176c',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_willsexch.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_willsexch.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '1xbetfair.club',
            apiDomain: '1xbetfair.club',
            name: '1xbetfair',
            dName: '1xbetfair',
            ext: '.club',
            theme: 'blue-body',
            email: 'info1xbetfair@gmail.com',
            content: 'Welcome to 1xbetfair, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: true,
                wpLink: 'https://go.wa.link/1xbetfairsupport',
                fbLink: 'https://www.facebook.com/1xbetfair',
                instaLink: 'https://www.instagram.com/1xbetfair',
                telLink: 'https://t.me/onexbetfair',
                tel2Link: 'https://t.me/onexbetfairsupport',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/1xbetfair-club.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/apk-new-popup.png',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mahadev55.com',
            apiDomain: 'mahadev55.com',
            name: 'mahadev55',
            dName: 'mahadev55',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'sarpanchexchange.com',
            apiDomain: '1xbetfair.me',
            name: 'sarpanchexchange',
            dName: 'sarpanchexchange',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Sarpanch Exchange, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: true,
                wpLink: 'https://wa.me/918426005125',
                fbLink: 'https://www.facebook.com/sarpanchexchnage',
                instaLink: 'https://www.instagram.com/sarpanchexchange?igsh=MWZyMGdhcTE5cDM1ZA%3D%3D&utm_source=qr',
                telLink: 'https://t.me/sarpanchexchange',
                tel2Link: 'https://t.me/sarpanchexchange',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'fairplay.city',
            apiDomain: 'fairplay.city',
            name: 'fairplay',
            dName: 'fairplay',
            ext: '.city',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Fairplay, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_fairplay.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_fairplay.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'sherexchange.com',
            apiDomain: 'sherexchange.com',
            name: 'sherexchange',
            dName: 'sherexchange',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Sherexchange, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_hub.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_hub.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'lexus247.com',
            apiDomain: 'lexus247.com',
            name: 'lexus247',
            dName: 'lexus247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to lexus247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'fdf9a08dc1f2bfa9cffa',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_purplefull.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_purplefull.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mglion777.io',
            apiDomain: 'mglion777.io',
            name: 'mglion777',
            dName: 'mglion777',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to mglion777, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'fdf9a08dc1f2bfa9cffa',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_greenfull.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_greenfull.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'funplay247.com',
            apiDomain: 'funplay247.com',
            name: 'funplay247',
            dName: 'funplay247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to funplay247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'fdf9a08dc1f2bfa9cffa',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_funplay.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_funplay.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '365deal.club',
            apiDomain: '365deal.club',
            name: '365deal',
            dName: '365deal',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to 365 Deal, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'fdf9a08dc1f2bfa9cffa',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'jazbaexchange.com',
            apiDomain: 'jazbaexchange.com',
            name: 'jazbaexchange',
            dName: 'jazbaexchange',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Jazba Exchange, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: 'https://wa.link/jazba55book',
            guestWhatsappLink: 'https://wa.link/jazba55book',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/jazba55book',
                fbLink: '',
                instaLink: 'https://www.instagram.com/jazba55book',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '5b1dec503fbd6e8b176c',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_hub.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_hub.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'tigerexchange.pro',
            apiDomain: '1xbetfair.me',
            name: 'tigerexchange',
            dName: 'tigerexchange',
            ext: '.pro',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Tiger Exchange, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_crickbuzz247.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_crickbuzz247.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'punjabexchange.com',
            apiDomain: 'punjabexchange.com',
            name: 'punjabexchange',
            dName: 'punjabexchange',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Tiger Exchange, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: true,
            demoLoginWpLink: 'https://wa.link/junoon247',
            guestWhatsappLink: 'https://wa.link/junoon247',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/punjabexchange',
                fbLink: '',
                instaLink: 'https://www.instagram.com/junoon247book',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_blue.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_blue.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'shaheenexch.com',
            apiDomain: 'shaheenexch.com',
            name: 'shaheenexch',
            dName: 'shaheenexch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Tiger Exchange, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/shaheenbook',
                fbLink: '',
                instaLink: 'https://www.instagram.com/shaheen.book',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_blue.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_blue.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'ambikaonline.com',
            apiDomain: 'ambikaonline.com',
            name: 'ambikaexch',
            dName: 'ambikaexch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: true,
                wpLink: 'https://go.wa.link/ambikaexchangesupport',
                fbLink: 'https://www.facebook.com/ambikaexchangeofficial',
                instaLink: 'https://www.instagram.com/ambikaexchangeofficial',
                telLink: 'https://t.me/Ambikaexchangeofficial',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://ambikaexch.online/AmbikaExch.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_ambika.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_ambika.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'p247.in',
            apiDomain: 'p247.in',
            name: 'p247',
            dName: 'p247',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://wa.me/+447452323904',
            guestWhatsappLink: 'https://wa.me/+447452323904',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'adda777.com',
            apiDomain: 'adda777.com',
            name: 'adda777',
            dName: 'adda777',
            ext: '.com',
            theme: 'blue-body',
            email: 'infoadda777@gmail.com',
            content: 'Welcome to adda777, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. adda777 is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. adda777 is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/adda777',
                fbLink: 'https://www.facebook.com/adda777',
                instaLink: 'https://www.instagram.com/adda777',
                telLink: 'https://t.me/onexbetfair',
                tel2Link: 'https://t.me/onexbetfairsupport',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'fdf9a08dc1f2bfa9cffa',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'laxmi55.com',
            apiDomain: 'laxmi55.com',
            name: 'laxmi55',
            dName: 'laxmi55',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Laxmi 55, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/laxmi55',
                fbLink: '',
                instaLink: 'https://www.instagram.com/betindia55book',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '5b1dec503fbd6e8b176c',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_hub.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_hub.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'linebazar.xyz',
            apiDomain: 'linebazar.xyz',
            name: 'linebazar',
            dName: 'linebazar',
            ext: '.xyz',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Line Bazar, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_crickbuzz247.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_crickbuzz247.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'testawl247.com',
            apiDomain: 'testawl247.com',
            name: 'testawl247',
            dName: 'testawl247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to testawl 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '5b1dec503fbd6e8b176c',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'shiva247exch.com',
            apiDomain: 'shiva247exch.com',
            name: 'shiva247exch',
            dName: 'shiva247exch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Shiva 247 Exch, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '957d2dd7ae5f87661d90',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://shiva247exch.com/assets/img/shiva247exch/popup-shiva247exch-new2.webp',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'reddyanna11.com',
            apiDomain: 'reddyanna11.com',
            name: 'reddyanna11',
            dName: 'reddyanna11',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Reddyanna 11, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://go.wa.link/1xfairplay',
            guestWhatsappLink: 'https://go.wa.link/1xfairplay',
            social: {
                isShow: true,
                wpLink: 'https://go.wa.link/1xfairplay',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '957d2dd7ae5f87661d90',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/ReddyAnna.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_reddybook.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_reddybook.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mycric77.com',
            apiDomain: 'mycric77.com',
            name: 'mycric77',
            dName: 'mycric77',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to mycric 77, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://go.wa.link/1xfairplay',
            guestWhatsappLink: 'https://go.wa.link/1xfairplay',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/reddyanna11official',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '957d2dd7ae5f87661d90',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/Mycric77.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-mycric77-1xfairplay.webp',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_crickbuzz247.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_crickbuzz247.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'silverbook247.co',
            apiDomain: 'silverbook247.co',
            name: 'silverbook247',
            dName: 'silverbook247',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Silver Book 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/247support',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '957d2dd7ae5f87661d90',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_silver.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_silver.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'swastikexch.com',
            apiDomain: 'swastikexch.com',
            name: 'swastikexch',
            dName: 'swastikexch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-casino-fifa2026-new2.webp',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'kabooks.club',
            apiDomain: '1xbetfair.me',
            name: 'kabooks',
            dName: 'kabooks',
            ext: '.club',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: true,
            demoLoginWpLink: 'https://wa.link/kabooks',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_skyexch.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_skyexch.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'kabook777.club',
            apiDomain: '1xbetfair.me',
            name: 'kabook777',
            dName: 'kabook777',
            ext: '.club',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: true,
            demoLoginWpLink: 'https://w.app/kabook',
            guestWhatsappLink: 'https://w.app/kabook',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_skyexch.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_skyexch.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:`<script>
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1856576558647733');
fbq('track', 'PageView');
</script>
<noscript><img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=1856576558647733&ev=PageView&noscript=1"
/></noscript>`,
        },
        {
            domain: 'omkaar247.in',
            apiDomain: '1xbetfair.me',
            name: 'omkaar247',
            dName: 'omkaar247',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'omkaar247.com',
            apiDomain: '1xbetfair.me',
            name: 'omkaar247',
            dName: 'omkaar247',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mahadevbook888.com',
            apiDomain: '1xbetfair.me',
            name: 'mahadevbook888',
            dName: 'mahadevbook888',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Mahadev Book 888, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://w.app/mahadevbookofficial',
            guestWhatsappLink: 'https://w.app/mahadevbookofficial',
            social: {
                isShow: true,
                wpLink: 'https://w.app/mahadevbookofficial',
                fbLink: '',
                instaLink: 'https://www.instagram.com/mahadevbook_official_helpline_/',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'assets/apk-mahadevbook888.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-mahadevbook888.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_blue.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_blue.css'],
            tawkToSrc: '',
            gTag: true,
            metaSeoContent:`<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-WD8BXMTK');</script>`,
        },
        {
            domain: '9wicket365.com',
            apiDomain: '1xbetfair.me',
            name: '9wicket365',
            dName: '9wicket365',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to 9 Wicket 365, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: '',
            signUpActive: false,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/ipl2026-popup.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'kailasha247.com',
            apiDomain: 'kailasha247.com',
            name: 'kailasha247',
            dName: 'kailasha247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mahaveerbook.online',
            apiDomain: 'mahaveerbook.online',
            name: 'mahaveerbook',
            dName: 'mahaveerbook',
            ext: '.online',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Mahaveer Book, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/ipl2026-popup.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mahaveerbook.live',
            apiDomain: 'mahaveerbook.live',
            name: 'mahaveerbook',
            dName: 'mahaveerbook',
            ext: '.live',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Mahaveer Book, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/ipl2026-popup.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_greenfull.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_greenfull.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'vraj247.com',
            apiDomain: 'vraj247.com',
            name: 'vraj247',
            dName: 'vraj247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://wa.link/vrajcustomer',
            guestWhatsappLink: 'https://wa.link/vrajcustomer',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/vrajcustomer',
                fbLink: '',
                instaLink: 'https://www.instagram.com/vrajbook?igsh=MWNxdWcyM3pxeXFubw==',
                telLink: 'https://t.me/vrajbook66',
                tel2Link: 'https://t.me/vrajbook66',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'crex247.win',
            apiDomain: '1xbetfair.me',
            name: 'crex247',
            dName: 'crex247',
            ext: '.win',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Crex 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://go.wa.link/crex247',
            guestWhatsappLink: 'https://go.wa.link/crex247',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/Crex247.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/apk-download.webp',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_reddybook.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_reddybook.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'kheloindia777.com',
            apiDomain: 'kheloindia777.com',
            name: 'kheloindia777',
            dName: 'kheloindia777',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'maruti247.co',
            apiDomain: 'maruti247.co',
            name: 'maruti247',
            dName: 'maruti247',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'kings247.io',
            apiDomain: 'kings247.io',
            name: 'kings247',
            dName: 'kings247',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: 'https://api.whatsapp.com/send?phone=447440537752&text=Hii%20Kings247%20%F0%9F%91%8B%0A%0ANeed%20New%20%F0%9F%86%94%20%E2%9C%A8',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'oscaronline247.com',
            apiDomain: '1xbetfair.me',
            name: 'oscaronline247',
            dName: 'oscaronline247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Oscar Online 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://go.wa.link/oscaronline247',
            guestWhatsappLink: 'https://go.wa.link/oscaronline247',
            social: {
                isShow: true,
                wpLink: 'https://go.wa.link/oscaronline247',
                fbLink: 'https://www.facebook.com/share/1ZmJHnKk6s/',
                instaLink: 'https://instagram.com/oscaronlinebook?igshid=YmMyMTA2M2Y=',
                telLink: 'https://t.me/oscaronlinebook',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/Oscar247.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/apk-download.webp',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'vardan247.club',
            apiDomain: 'vardan247.com',
            name: 'vardan247',
            dName: 'vardan247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Vardan 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/ipl2026-popup.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'pakplay365.com',
            apiDomain: 'pakplay365.com',
            name: 'pakplay365',
            dName: 'pakplay365',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Pakplay 365, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: 'https://wa.link/pakplay365com',
            guestWhatsappLink: 'https://wa.link/pakplay365com',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '5b1dec503fbd6e8b176c',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_hub.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_hub.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'rakaexch.com',
            apiDomain: 'rakaexch.com',
            name: 'rakaexch',
            dName: 'rakaexch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Raka Exch, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '5b1dec503fbd6e8b176c',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_hub.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_hub.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'bhola777.com',
            apiDomain: 'bhola777.com',
            name: 'bhola777',
            dName: 'bhola777',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: 'https://api.whatsapp.com/send?phone=919662256439&text=Hiii',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_darkpink.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_darkpink.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'coolbet247.co',
            apiDomain: '1xbetfair.me',
            name: 'coolbet247',
            dName: 'coolbet247',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to coolbet247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: false,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: 'https://go.wa.link/1xbetfairsupport',
                fbLink: 'https://www.facebook.com/1xbetfeir',
                instaLink: 'https://www.instagram.com/1xbetfeir?igsh=enRiNXdnOTZjbXFk&utm_source=qr',
                telLink: 'https://t.me/onexbetfair',
                tel2Link: 'https://t.me/onexbetfairsupport',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_blueblack.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_blueblack.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'koka247.com',
            apiDomain: '1xbetfair.me',
            name: 'koka247',
            dName: 'koka247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: true,
            demoLoginWpLink: 'https://wa.link/koka247',
            guestWhatsappLink: 'https://wa.link/koka247',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_skyexch.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_skyexch.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'reddybook77.com',
            apiDomain: 'reddybook77.com',
            name: 'reddybook77',
            dName: 'reddybook77',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to reddybook 77, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://go.wa.link/1xfairplay',
            guestWhatsappLink: 'https://go.wa.link/1xfairplay',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '957d2dd7ae5f87661d90',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_reddybook.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_reddybook.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'reddyanna11.io',
            apiDomain: '1xbetfair.me',
            name: 'reddyanna11',
            dName: 'reddyanna11',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Reddyanna 11, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://go.wa.link/1xfairplay',
            guestWhatsappLink: 'https://go.wa.link/1xfairplay',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '957d2dd7ae5f87661d90',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/ReddyAnna.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/apk-download.webp',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_reddybook.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_reddybook.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'allrounder99.com',
            apiDomain: '1xbetfair.me',
            name: 'allrounder99',
            dName: 'allrounder99',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to All Rounder 999, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://awl247wa.com/business/allrounder99',
            guestWhatsappLink: 'https://awl247wa.com/business/allrounder99',
            social: {
                isShow: true,
                wpLink: 'https://awl247wa.com/business/allrounder99',
                fbLink: 'https://facebook.com/Allrounder99official',
                instaLink: 'https://www.instagram.com/allrounder99official',
                telLink: 'https://t.me/all_rounder99',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/AllRounder.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-allrounder99.webp',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_lightblue.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_lightblue.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'uro777.com',
            apiDomain: '1xbetfair.me',
            name: 'uro777',
            dName: 'uro777',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to URO 777, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '957d2dd7ae5f87661d90',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_redblack.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_redblack.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'shreenathexchange.com',
            apiDomain: 'shreenathexchange.com',
            name: 'shreenathexchange',
            dName: 'shreenathexchange',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'thediamond247.org',
            apiDomain: 'alexisly.com',
            name: 'thediamond247',
            dName: 'thediamond247',
            ext: '.org',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to The Diamond 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://wa.me/918618942876',
            guestWhatsappLink: 'https://wa.me/918618942876',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'jeetbhai247.com',
            apiDomain: 'alexisly.com',
            name: 'jeetbhai247',
            dName: 'jeetbhai247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to The Jeetbhai 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'vardan247.club',
            apiDomain: 'alexisly.com',
            name: 'vardan247',
            dName: 'vardan247',
            ext: '.club',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to The Vardan 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mybet111.com',
            apiDomain: 'alexisly.com',
            name: 'mybet111',
            dName: 'mybet111',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to The Mybet 111, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: false,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_lightblue.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_lightblue.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mybet111.net',
            apiDomain: 'alexisly.com',
            name: 'mybet111',
            dName: 'mybet111',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to The Mybet 111, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: false,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_green.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_green.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'vardan247.live',
            apiDomain: 'alexisly.com',
            name: 'vardan247',
            dName: 'vardan247',
            ext: '.live',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Vardan 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_vardan.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_vardan.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '1xbetfair.dev',
            apiDomain: 'alexisly.com',
            name: '1xbetfair',
            dName: '1xbetfair',
            ext: '.dev',
            theme: 'blue-body',
            email: 'info1xbetfair@gmail.com',
            content: 'Welcome to 1xbetfair, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://awl247wa.com/casino/1xbetfair',
            guestWhatsappLink: 'https://awl247wa.com/casino/1xbetfair',
            social: {
                isShow: true,
                wpLink: 'https://awl247wa.com/casino/1xbetfair',
                fbLink: 'https://www.facebook.com/1xbetfeir',
                instaLink: 'https://www.instagram.com/1xbetfeir?igsh=enRiNXdnOTZjbXFk&utm_source=qr',
                telLink: 'https://t.me/onexbetfair',
                tel2Link: 'https://t.me/onexbetfairsupport',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/1xbetfair.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-1xbetfair-apk-download2026.webp',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: 'https://embed.tawk.to/69e5d2696ef56e1c36f545c8/1jmkrrrco',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'thala99.com',
            apiDomain: 'alexisly.com',
            name: 'thala99',
            dName: 'thala99',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Thala 99, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_crickbuzz247.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_crickbuzz247.css'],
            tawkToSrc: 'https://embed.tawk.to/69e5d2696ef56e1c36f545c8/1jmkrrrco',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'devonline777.com',
            apiDomain: 'devonline777.com',
            name: 'devonline777',
            dName: 'devonline777',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_devoline.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_devoline.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '1xbetfair.me',
            apiDomain: 'alexisly.com',
            name: '1xbetfair',
            dName: '1xbetfair',
            ext: '.me',
            theme: 'blue-body',
            email: 'info1xbetfair@gmail.com',
            content: 'Welcome to 1xbetfair, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://awl247wa.com/casino/1xbetfair',
            guestWhatsappLink: 'https://awl247wa.com/casino/1xbetfair',
            social: {
                isShow: true,
                wpLink: 'https://awl247wa.com/casino/1xbetfair',
                fbLink: 'https://www.facebook.com/1xbetfeir',
                instaLink: 'https://www.instagram.com/1xbetfeir?igsh=enRiNXdnOTZjbXFk&utm_source=qr',
                telLink: 'https://t.me/onexbetfair',
                tel2Link: 'https://t.me/onexbetfairsupport',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/1xbetfair.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-1xbetfair-apk-download2026.webp',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: 'https://embed.tawk.to/69e5d2696ef56e1c36f545c8/1jmkrrrco',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'sydney777.io',
            apiDomain: 'sydney777.io',
            name: 'sydney777',
            dName: 'sydney777',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://wa.link/sydney777',
            guestWhatsappLink: 'https://wa.link/sydney777',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mortune247.co.uk',
            apiDomain: 'mortune247.co.uk',
            name: 'mortune247',
            dName: 'mortune247',
            ext: '.co.uk',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'reddy22.com',
            apiDomain: 'alexisly.com',
            name: 'reddy22',
            dName: 'reddy22',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://go.wa.link/reddy22',
            guestWhatsappLink: 'https://go.wa.link/reddy22',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_reddybook.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_reddybook.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'rudraexchange.com',
            apiDomain: 'alexisly.com',
            name: 'rudraexchange',
            dName: 'rudraexchange',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Rudra Exchange, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://go.wa.link/rudraexchange',
            guestWhatsappLink: 'https://go.wa.link/rudraexchange',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '957d2dd7ae5f87661d90',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_myMatch.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_myMatch.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'rocky777.live',
            apiDomain: 'rocky777.live',
            name: 'rocky777',
            dName: 'rocky777',
            ext: '.live',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_wold77.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_wold77.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'fortune247.co.uk',
            apiDomain: 'fortune247.co.uk',
            name: 'fortune247',
            dName: 'fortune247',
            ext: '.co.uk',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: false,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_wold77.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_wold77.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mahadevbook247.club',
            apiDomain: '1xbetfair.me',
            name: 'mahadevbook247',
            dName: 'mahadevbook247',
            ext: '.club',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Mahadevbook 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://w.app/mahadev',
            guestWhatsappLink: 'https://w.app/mahadev',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_blue.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_blue.css'],
            tawkToSrc: '',
            gTag: true,
            metaSeoContent:'',
        },
        {
            domain: 'rocky247.live',
            apiDomain: 'rocky247.live',
            name: 'rocky247',
            dName: 'rocky247',
            ext: '.live',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Rocky 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: '',
            signUpActive: false,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/ipl2026-popup.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: true,
            metaSeoContent:'',
        },
        {
            domain: 'moneybhai247.com',
            apiDomain: '1xbetfair.me',
            name: 'moneybhai247',
            dName: 'moneybhai247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Money Bhai 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mycircle247.site',
            apiDomain: 'mycircle247.site',
            name: 'mycircle247',
            dName: 'mycircle247',
            ext: '.site',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'andaaz365.com',
            apiDomain: 'andaaz365.com',
            name: 'andaaz365',
            dName: 'andaaz365',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Andaaz 365, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: '',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '5b1dec503fbd6e8b176c',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_hub.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_hub.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'avexchanges.com',
            apiDomain: 'alexisly.com',
            name: 'avexchanges',
            dName: 'avexchanges',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to AV Exchanges, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://bio.wa.link/avexchanges',
            guestWhatsappLink: 'https://bio.wa.link/avexchanges',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'avexchanges.online',
            apiDomain: 'alexisly.com',
            name: 'avexchanges',
            dName: 'avexchanges',
            ext: '.online',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to AV Exchanges, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://bio.wa.link/avexchanges',
            guestWhatsappLink: 'https://bio.wa.link/avexchanges',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'shiva222.com',
            apiDomain: 'alexisly.com',
            name: 'shiva222',
            dName: 'shiva222',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Shiva 222, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://awl247wa.com/casino/shiva222',
            guestWhatsappLink: 'https://awl247wa.com/casino/shiva222',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'jeetexch.live',
            apiDomain: 'alexisly.com',
            name: 'jeetexch',
            dName: 'jeetexch',
            ext: '.live',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Jee Texch, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://bio.wa.link/jeetexch',
            guestWhatsappLink: 'https://bio.wa.link/jeetexch',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'shivaa.space',
            apiDomain: 'alexisly.com',
            name: 'shivaa',
            dName: 'shivaa',
            ext: '.space',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Shiva 222, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://awl247wa.com/casino/shiva222',
            guestWhatsappLink: 'https://awl247wa.com/casino/shiva222',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'bhagwabook.com',
            apiDomain: 'alexisly.com',
            name: 'bhagwabook',
            dName: 'bhagwabook',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to AV Exchanges, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mahadevbook777.club',
            apiDomain: 'alexisly.com',
            name: 'mahadevbook777',
            dName: 'mahadevbook777',
            ext: '.club',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Mahadev Book 777, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://bio.wa.link/jeetexch',
            guestWhatsappLink: 'https://bio.wa.link/jeetexch',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_blue.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_blue.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'reddyanna247.pro',
            apiDomain: 'alexisly.com',
            name: 'reddyanna247',
            dName: 'reddyanna247',
            ext: '.pro',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Reddy Anna 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://w.app/-reddyannaofficial',
            guestWhatsappLink: 'https://w.app/-reddyannaofficial',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_blackgold.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_blackgold.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'supreme247.live',
            apiDomain: 'alexisly.com',
            name: 'supreme247',
            dName: 'supreme247',
            ext: '.live',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Supreme 247, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '1xbetfair.online',
            apiDomain: 'alexisly.com',
            name: '1xbetfair',
            dName: '1xbetfair',
            ext: '.onlinee',
            theme: 'blue-body',
            email: 'info1xbetfair@gmail.com',
            content: 'Welcome to 1xbetfair, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://awl247wa.com/casino/1xbetfair',
            guestWhatsappLink: 'https://awl247wa.com/casino/1xbetfair',
            social: {
                isShow: true,
                wpLink: 'https://awl247wa.com/casino/1xbetfair',
                fbLink: 'https://www.facebook.com/1xbetfeir',
                instaLink: 'https://www.instagram.com/1xbetfeir?igsh=enRiNXdnOTZjbXFk&utm_source=qr',
                telLink: 'https://t.me/onexbetfair',
                tel2Link: 'https://t.me/onexbetfairsupport',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/1xbetfair.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-1xbetfair-me-dev.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: 'https://embed.tawk.to/69e5d2696ef56e1c36f545c8/1jmkrrrco',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'mahadevbook8888.com',
            apiDomain: 'alexisly.com',
            name: 'mahadevbook8888',
            dName: 'mahadevbook8888',
            ext: '.club',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to Mahadev Book 888, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://wa.link/mahadevbookorignal',
            guestWhatsappLink: 'https://wa.link/mahadevbookorignal',
            social: {
                isShow: true,
                wpLink: 'https://wa.link/mahadevbookorignal',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: '',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_blue.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_blue.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '247winplay.com',
            apiDomain: '247winplay.com',
            name: '247winplay',
            dName: '247winplay',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'adani777.co',
            apiDomain: 'adani777.co',
            name: 'adani777',
            dName: 'adani777',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://wa.me/+919334949520',
            guestWhatsappLink: 'https://wa.me/+919334949520',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_mango.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_mango.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'falcon777.co',
            apiDomain: 'falcon777.co',
            name: 'falcon777',
            dName: 'falcon777',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: 'https://wa.me/+917984944372',
            guestWhatsappLink: 'https://wa.me/+917984944372',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'world77.me',
            apiDomain: '1xbetfair.me',
            name: 'world77',
            dName: 'world77',
            ext: '.me',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_redblack.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_redblack.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'uro777.live',
            apiDomain: '1xbetfair.me',
            name: 'uro777',
            dName: 'uro777',
            ext: '.live',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_redblack.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_redblack.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '1xbetfair.io',
            apiDomain: 'alexisly.com',
            name: '1xbetfair',
            dName: '1xbetfair',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to 1xbetfair, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://awl247wa.com/casino/1xbetfair',
            guestWhatsappLink: 'https://awl247wa.com/casino/1xbetfair',
            social: {
                isShow: true,
                wpLink: 'https://awl247wa.com/casino/1xbetfair',
                fbLink: 'https://www.facebook.com/1xbetfeir',
                instaLink: 'https://www.instagram.com/1xbetfeir?igsh=enRiNXdnOTZjbXFk&utm_source=qr',
                telLink: 'https://t.me/onexbetfair',
                tel2Link: 'https://t.me/onexbetfairsupport',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/1xbetfair.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-1xbetfair-me-dev.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: 'https://embed.tawk.to/69e5d2696ef56e1c36f545c8/1jmkrrrco',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: '1xbetfair.uk',
            apiDomain: 'alexisly.com',
            name: '1xbetfair',
            dName: '1xbetfair',
            ext: '.uk',
            theme: 'blue-body',
            email: '',
            content: 'Welcome to 1xbetfair, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. This Site is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License No.is: B2C-669UN7GS-2678JAZ. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.',
            whatsapptext: 'Get Your Instatnt ID From Whatsapp',
            guestEnable: true,
            demoLogin: true,
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            depoWithdraw: true,
            demoLoginWpLink: 'https://awl247wa.com/casino/1xbetfair',
            guestWhatsappLink: 'https://awl247wa.com/casino/1xbetfair',
            social: {
                isShow: true,
                wpLink: 'https://awl247wa.com/casino/1xbetfair',
                fbLink: 'https://www.facebook.com/1xbetfeir',
                instaLink: 'https://www.instagram.com/1xbetfeir?igsh=enRiNXdnOTZjbXFk&utm_source=qr',
                telLink: 'https://t.me/onexbetfair',
                tel2Link: 'https://t.me/onexbetfairsupport',
            },
            footerone: {
                isShow: true,
            },
            footertwo: {
                isShow: true,
            },
            footerthree: {
                isShow: true,
            },
            footerbottomone: {
                isShow: true,
            },
            footerbottomtwo: {
                isShow: true,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            downloadApk: 'https://allwhitelabel247.com/1xbetfair.apk',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-1xbetfair-me-dev.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme_1xbetfair.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme_1xbetfair.css'],
            tawkToSrc: 'https://embed.tawk.to/69e5d2696ef56e1c36f545c8/1jmkrrrco',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'malamaal777.com',
            apiDomain: 'malamaal777.com',
            name: 'malamaal777',
            dName: 'malamaal777',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: false,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: false,
                wpLink: '',
                fbLink: '',
                instaLink: '',
                telLink: '',
                tel2Link: '',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
        {
            domain: 'hinduexch.com',
            apiDomain: 'hinduexch.com',
            name: 'hinduexch',
            dName: 'hinduexch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            content: '',
            whatsapptext: '',
            guestEnable: true,
            demoLogin: true,
            signUpActive: true,
            iframeDomainUrl: 'https://77panel.co/',
            depoWithdraw: false,
            demoLoginWpLink: '',
            guestWhatsappLink: '',
            social: {
                isShow: true,
                wpLink: '',
                fbLink: 'https://www.facebook.com/share/1Audt7Wgas/',
                instaLink: 'https://www.instagram.com/newhindu777/',
                telLink: 'https://t.me/hindu777tips',
                tel2Link: 'https://t.me/hindu777tips',
            },
            footerone: {
                isShow: false,
            },
            footertwo: {
                isShow: false,
            },
            footerthree: {
                isShow: false,
            },
            footerbottomone: {
                isShow: false,
            },
            footerbottomtwo: {
                isShow: false,
            },
            ftLivetvData: 'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            downloadApk: '',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/diamond-client-v8/popup-new.jpg',
            mThemePath: ['assets/css/mobile/common.css', 'assets/css/mobile/m-style.css', 'assets/css/mobile/custom.css', 'assets/css/mobile/theme.css'],
            dThemePath: ['assets/css/desktop/common.css', 'assets/css/desktop/style.css', 'assets/css/desktop/custom.css', 'assets/css/desktop/theme.css'],
            tawkToSrc: '',
            gTag: false,
            metaSeoContent:'',
        },
    ],
};
